import api from 'Application/api/api';

const createProjectInsurance = async (signal, values) => {
	const response = await api.post('/insurances/create', values, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default createProjectInsurance;
